// src/services/pagosService.js
import { getAuthHeader } from "./authService";

const BASE_URL =
  (process.env.REACT_APP_BACKEND_URL || "http://localhost:3001").replace(
    /\/$/,
    ""
  );

const PAGOS_URL = `${BASE_URL}/api/v1/pagos`;

/* ===== Helpers ===== */
const toJson = async (res) => {
  try {
    const json = await res.json();
    return json;
  } catch (e) {
    console.warn("[PAGOS][WARN] No se pudo parsear JSON", e);
    return {};
  }
};

const ensureOk = (res, data) => {
  if (!res.ok) {
    console.error("[PAGOS][ERROR] Request falló:", res.status, data);
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
};

const clean = (obj) => {
  const out = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
};

export async function listPagos() {
  const url = `${PAGOS_URL}/pagos-all`;
  const headers = { Accept: "application/json", ...getAuthHeader() };

  const res = await fetch(url, { headers });

  const data = await toJson(res);

  ensureOk(res, data);

  const salida = Array.isArray(data) ? data : data?.data ?? [];

  return salida;
}

export async function createPago(form) {
  // Por defecto usamos el mismo esquema que tu ejemplo
  const payload = clean({
    representante_id: form.representante_id,
    deportista_id: form.deportista_id,
    producto_id: form.producto_id,
    periodo: form.periodo,
    fecha_vencimiento: form.fecha_vencimiento,
    estado: form.estado || "pending",
    tipo_pago: form.tipo_pago ?? null,
    comprobante_url: form.comprobante_url ?? null,
    confirmado_por: form.confirmado_por ?? null,
    fecha_confirmacion: form.fecha_confirmacion ?? null,
    comentario: form.comentario,
  });

  const url = `${PAGOS_URL}`;
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...getAuthHeader(),
  };
  const res = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  });

  const data = await toJson(res);

  ensureOk(res, data);

  const salida = data?.data ?? data;

  return salida;
}

export async function updatePago(form) {
  if (!form.id) {
    throw new Error("ID del pago es requerido para actualizar");
  }

  const formData = new FormData();

  const append = (key, value) => {
    if (value === undefined || value === null) return;
    if (typeof value === "string" && value.trim() === "") return;
    formData.append(key, value);
  };

  append("representante_id", form.representante_id);
  append("deportista_id", form.deportista_id);
  append("producto_id", form.producto_id);
  append("periodo", form.periodo);
  append("fecha_vencimiento", form.fecha_vencimiento);
  append("estado", form.estado);
  append("tipo_pago", form.tipo_pago);
  // Solo enviar comprobante_url si existe y no es una URL procesada (data:image)
  if (form.comprobante_url && !String(form.comprobante_url).startsWith("data:image")) {
    append("comprobante_url", form.comprobante_url);
  }
  append("confirmado_por", form.confirmado_por);

  const fechaConf =
    form.fecha_confirmacion || new Date().toISOString().slice(0, 10);
  append("fecha_confirmacion", fechaConf);

  append("comentario", form.comentario);

  const url = `${PAGOS_URL}/${form.id}`;
  const headers = {
    Accept: "application/json",
    ...getAuthHeader(),
  };

  const res = await fetch(url, {
    method: "PUT",
    headers,
    body: formData,
  });

  const data = await toJson(res);

  ensureOk(res, data);

  const salida = data?.data ?? data;

  return salida;
}
